import { STATE_AND_PROVINCE_OPTIONS } from 'src/lib/usStates'

export const states = STATE_AND_PROVINCE_OPTIONS.map((region) => region.label)

export const stateAbbreviations = STATE_AND_PROVINCE_OPTIONS.map(
  (region) => region.value
)
